import { h } from 'preact'

const handleOpenEmbeddables = () => {
  const embeddablesButton: HTMLElement | null = document.querySelector('.insided-conversational-trigger-button')

  if (embeddablesButton) {
    embeddablesButton.click()
  }
}

const ControlNote = () => {
  return (
    <div className='customCss__note'>
      <p className='customCss__note-text'><span className='customCss__note-text-bold'>Note:</span> We moved the customization options for Buttons,
        Colors, Fonts and Custom CSS to our new "Theme" mode. <button className='customCss__note-text-btn' type='button'
        onClick={handleOpenEmbeddables}>Learn more</button></p>
    </div>
  )
}

export default ControlNote
